const pluralize = (count: unknown, singular: string, plural: string): string =>
  count == 1 ? singular : plural;

export default pluralize;
